import {
  Routes, Route, useLocation, Navigate, Outlet,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import BackupsProvider from './context/Backups';
import SignInPage from './pages/SignIn';
import HomePage from './pages/Home';
import NewBackupPage from './pages/NewBackup';
import NewWorkspacePage from './pages/NewWorkspace';
import ReportsPage from './pages/Reports';
import SignUpPage from './pages/SignUp';
import useAuth from './hooks/useAuth';
import WorkspacePage from './pages/Workspace';
import WorkspacesProvider from './context/Workspaces';
import ForgotPasswordPage from './pages/ForgotPassword';
import Loader from './components/Loader';
import OverviewPage from './pages/Overview';
import NewCompanyPage from './pages/NewCompany';

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={(
          <RedirectCaseAuthenticated>
            <SignInPage />
          </RedirectCaseAuthenticated>
        )}
      />
      <Route
        path="/sign-up"
        element={(
          <RedirectCaseAuthenticated>
            <SignUpPage />
          </RedirectCaseAuthenticated>
        )}
      />
      <Route
        path="/forgot-password"
        element={(
          <ForgotPasswordPage />
        )}
      />
      <Route
        path="/reset-password/:id/:token"
        element={(
          <ForgotPasswordPage />
        )}
      />
      <Route element={<PrivateRoute />}>
        <Route
          path="/home"
          element={(<HomePage />)}
        />
        <Route
          path="/new-workspace"
          element={(

            <NewWorkspacePage />
          )}
        />
        <Route
          path="/new-backup"
          element={(
            <NewBackupPage />
          )}
        />
        <Route
          path="/reports"
          element={(
            <ReportsPage />
          )}
        >
          <Route
            path=":backupId"
            element={(
              <ReportsPage />
            )}
          />
        </Route>
        <Route
          path="/workspaces/:id"
          element={(
            <WorkspacePage />
          )}
        >
          <Route path="members" element={<div />} />
        </Route>
        <Route
          path="/overview"
          element={(
            <OverviewPage />
          )}
        />
        <Route
          path="/new-company"
          element={(
            <NewCompanyPage />
          )}
        />
      </Route>
    </Routes>
  );
}

function PrivateRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <Loader />;
  }
  if (isLoading === false && isAuthenticated) {
    return (
      <WorkspacesProvider>
        <BackupsProvider>
          <Outlet />
        </BackupsProvider>
      </WorkspacesProvider>
    );
  }

  return <Navigate to="/" state={{ from: location }} replace />;
}

function RedirectCaseAuthenticated({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  if (!isLoading && isAuthenticated) {
    return <Navigate to={location.state?.from.pathname ?? '/home'} />;
  }

  return children;
}

RedirectCaseAuthenticated.propTypes = {
  children: PropTypes.node.isRequired,
};
